
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--small",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"icon icon--small","xmlns":"http://www.w3.org/2000/svg","width":"30.31","height":"45.22","viewBox":"0 0 30.31 45.22","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.15 21.03c-5.8 0-10.52-4.72-10.52-10.52S9.35 0 15.15 0s10.52 4.72 10.52 10.52-4.72 10.51-10.52 10.51zm0-19.03c-4.7 0-8.52 3.82-8.52 8.52 0 4.7 3.82 8.52 8.52 8.52 4.7 0 8.52-3.82 8.52-8.52 0-4.7-3.82-8.52-8.52-8.52zM25.97 45.22H4.34C1.95 45.22 0 43.27 0 40.88v-3.69c0-.2.02-.4.07-.61.67-7.77 7.28-13.84 15.08-13.84s14.42 6.07 15.09 13.84c.05.21.07.41.07.61v3.69c0 2.39-1.95 4.34-4.34 4.34zM15.15 24.74c-6.79 0-12.55 5.3-13.1 12.07l-.02.16c-.02.08-.03.16-.03.22v3.69c0 1.29 1.05 2.34 2.34 2.34h21.63c1.29 0 2.34-1.05 2.34-2.34v-3.69c0-.06-.01-.13-.03-.22l-.02-.15c-.56-6.78-6.31-12.08-13.11-12.08z"}})])
          )
        }
      }
    